module.exports = __webpack_public_path__ + "images/5ee31c55e8d52b00bbae4f6c57815313.png";